/**
 * Reads a UTF-8 byte stream as text, calling onText for each decoded piece.
 *
 * One decoder in streaming mode: a letter split across network chunks (ä, õ, š, ā are two bytes)
 * waits for its second byte instead of becoming "�". The final decode() flushes what is left.
 */
export const readTextStream = async (
  body: ReadableStream<Uint8Array>,
  onText: (text: string) => void,
): Promise<void> => {
  const reader = body.getReader();
  const decoder = new TextDecoder();

  try {
    for (;;) {
      const { done, value } = await reader.read();
      const text = done ? decoder.decode() : decoder.decode(value, { stream: true });
      if (text) {
        onText(text);
      }
      if (done) {
        return;
      }
    }
  } finally {
    reader.releaseLock();
  }
};
